import React from "react"
import styled from "styled-components"
import { socialData } from "utils/data"
import bannerSrc from "assets/images/aboutme-banner.jpg"
import dotSrc from "assets/images/dot.png"
import authorSrc from "assets/images/author.jpg"

const Container = styled.div`
		padding: 130px 0;
		background: url(${bannerSrc}) no-repeat center;
		background-size: cover;
		position: relative;
		&::after {
			content: "";
			background: rgba(0, 0, 0, 0.7) url(${dotSrc});
			opacity: 0.5;
			position: absolute;
			top: 0;
			bottom: 0;
			right: 0;
			left: 0;
			z-index: 1;
		}
	`,
	ContentWrap = styled.div`
		text-align: center;
		position: relative;
		z-index: 2;
	`,
	Avatar = styled.img`
		width: 130px;
		padding: 4px;
		background: #fff;
		border-radius: 50%;
		@media (max-width: 467px) {
			width: 100px;
		}
	`,
	NickName = styled.h2`
		padding: 10px 0;
		color: #fff;
		font-size: 28px;
		font-weight: bold;
	`,
	SocialWrap = styled.ul`
		width: 70%;
		margin: 0 auto;
		@media (max-width: 467px) {
			width: 90%;
		}
	`,
	SocialItem = styled.li`
		padding: 5px;
		margin: 3px;
		background: rgba(0, 0, 0, 0.3);
		border-radius: 6px;
		display: inline-block;
		cursor: pointer;
	`,
	SocialItemIcon = styled.svg`
		font-size: 32px;
		/* border-radius: 50%; */
	`,
	Line = styled.hr`
		width: 70%;
		margin: 12px auto;
		border-width: 2px;
		border-style: dashed;
		border-color: #fff;
		@media (max-width: 467px) {
			width: 90%;
		}
	`,
	Introduce = styled.p`
		color: #fff;
		line-height: 1.4;
	`

export default function Banner() {
	return (
		<Container>
			<ContentWrap className="container">
				<Avatar src={authorSrc} />
				<NickName>stempest</NickName>
				<SocialWrap>
					{socialData.map((item, index) => (
						<SocialItem key={index}>
							<SocialItemIcon className="icon" ariaHidden="true">
								<use xlinkHref={`#${item.icon}`}></use>
							</SocialItemIcon>
						</SocialItem>
					))}
				</SocialWrap>
				<Line />
				<Introduce>前魔兽咕咕作者，现辣鸡前端狗，因为完美主义却又中度拖延，所以老是画饼不填。喜欢规划生活，结交志同道合的朋友。</Introduce>
			</ContentWrap>
		</Container>
	)
}
